// Instância única do cache do TanStack Query. Criada fora do main.tsx por dois
// motivos: (1) a guarda de rota (router.tsx, fora do React) lê o MESMO cache que
// as telas populam — em especial ["access","me"] (ACCESS_ME_QUERY_KEY), de onde
// sai o papel-base e as permissões do viewer; e (2) o helper de logout
// (auth-client.ts) limpa o cache sem depender de um hook.
import { QueryClient } from "@tanstack/react-query";

// Sem isto o default é staleTime 0 (toda query vira obsoleta na hora e refaz em cada
// mount/refoco) — cache curto demais. Mantemos os dados "frescos" por alguns minutos
// e em memória por mais tempo.
const STALE_TIME_MS = 5 * 60 * 1000; // 5 min: não refaz sozinho nesse intervalo
const GC_TIME_MS = 30 * 60 * 1000; // 30 min: mantém em cache após ficar inativo

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      gcTime: GC_TIME_MS,
      // Nenhum 4xx melhora com retry: o servidor entendeu o pedido e disse não
      // (401/403 sem permissão, 404 não existe, 410 foi removido, 422 inválido).
      // Além de ruído, repetir dispara quatro requests iguais em cada montagem —
      // e cada retry é uma janela em que uma oscilação de rede pode PAUSAR a
      // query, que então fica sem data, sem erro e sem carregar (tela em
      // branco). 5xx e falha de rede continuam merecendo insistência.
      retry(failureCount, error) {
        const status = (error as { status?: number }).status;
        if (status !== undefined && status >= 400 && status < 500) return false;
        return failureCount < 3;
      },
    },
  },
});
